import React, { Component } from "react"
import PropTypes from "prop-types"
import { MapWithMarkers, Tabs } from "components"
import LocationsSectionMapLocationContainer from "containers/map-location/locations-section"
import { withRadium, DetectCompact } from "higher-order-components"

class StaticDealerMapWithToggle extends Component {
  constructor(props) {
    super()
    this.state = {
      activeDepartmentIndex: props.initialDepartmentIndex || 0
    }
  }
  render() {
    const dealers = this.props.dealers.map(({ info }) => info)

    const options = this.props.dealers.map(({ label }) => label)

    let activeDealer = dealers[this.state.activeDepartmentIndex]

    activeDealer = {
      ...activeDealer,
      lat: Number(activeDealer.lat),
      lng: Number(activeDealer.lng)
    }

    const selector = (
      <Tabs
        onChange={(props, index) => {
          this.setState({ activeDepartmentIndex: index })
        }}
        divider
        active={this.state.activeDepartmentIndex}
        options={options.map(name => ({ name }))} />
    )

    const mapBlock = (
      <div style={{ display: "flex", textAlign: "left" }}>
        <div style={{ flex: "1 1 100%" }}>
          <LocationsSectionMapLocationContainer
            compact={this.props.compact}
            gtm={this.props.gtm}
            locations={[{
              active: true,
              animateHeight: false,
              ...activeDealer
            }]}
          />
        </div>
        {!this.props.compact &&
          <div style={{ position: "relative", flex: "1 1 100%" }}>
            <MapWithMarkers
              locations={[activeDealer]}
              activeIndex={0}
              options={{ disableDefaultUI: true }}
              map={{
                center: {
                  ...activeDealer
                },
                zoom: 17
              }} />
          </div>
        }
      </div>
    )

    const { children } = this.props

    return (
      children ?
        children({
          selector,
          mapBlock
        })
        :
        (
          <div style={{ textAlign: "center" }}>
            {selector}
            {mapBlock}
          </div>
        )
    )
  }
}


StaticDealerMapWithToggle.propTypes = {
  initialDepartmentIndex: PropTypes.number,
  children: PropTypes.func,
  compact: PropTypes.bool,
  dealers: PropTypes.arrayOf(
    PropTypes.shape({
      info: PropTypes.object,
      label: PropTypes.string
    })
  )
}

export default withRadium(DetectCompact())(StaticDealerMapWithToggle)



// WEBPACK FOOTER //
// ./src/components/static-dealer-map-with-toggle/index.jsx